import BZDZ from './zzjc/ysgltz/bzdz/bzdz'
import XZQH from './zzjc/ysgltz/bzdz/xzqh'
import CHJG from './zzjc/ysgltz/bzdz/chjg'
import SJ from './zzdd/czdd/sj.js'
import upload from './upload/upload'
import dictData from './sys/dictData'
import dept from './sys/dept'
import kxsfrz from './zzzc/fzgj/kxsfrz'

export default {
  BZDZ,// 标准地址
  XZQH,// 行政区划
  CHJG,// 层户结构
  SJ,// 事件
  upload,// 上传
  dictData,// dic data
  dept,
  kxsfrz,//
}
